// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dev {\n  margin-top: 48px;\n  display: flex;\n  gap: 32px;\n}\n", ""]);
// Exports
module.exports = exports;
